/**
 * Product Slider Navigation
 * Handles smart arrows (auto hide at limits) + scrollbar sync.
 */
(function () {
  'use strict';

  function initSlider(section) {
    var slider   = section.querySelector('[data-product-slider]');
    var prevBtns = section.querySelectorAll('[data-slider-prev]');
    var nextBtns = section.querySelectorAll('[data-slider-next]');
    var thumb    = section.querySelector('[data-slider-thumb]');

    if (!slider) return;

    function getScrollStep() {
      var item = slider.querySelector('.product-slider__item');
      if (!item) return 300;
      return (item.offsetWidth + 12) * 2;
    }

    function updateArrows() {
      var atStart = slider.scrollLeft <= 2;
      var atEnd   = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 2;

      prevBtns.forEach(function (btn) {
        btn.toggleAttribute('data-arrow-hidden', atStart);
      });
      nextBtns.forEach(function (btn) {
        btn.toggleAttribute('data-arrow-hidden', atEnd);
      });
    }

    function updateThumb() {
      if (!thumb) return;
      var ratio    = slider.clientWidth / slider.scrollWidth;
      var thumbW   = Math.max(ratio * 100, 10);
      var thumbL   = (slider.scrollLeft / slider.scrollWidth) * 100;
      thumb.style.width = thumbW + '%';
      thumb.style.left  = thumbL + '%';
    }

    function scrollTo(dir) {
      slider.scrollBy({ left: dir * getScrollStep(), behavior: 'smooth' });
    }

    prevBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { scrollTo(-1); });
    });
    nextBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { scrollTo(1); });
    });

    // Scrollbar click — sélecteur mis à jour vers le composant partagé
    var track = section.querySelector('[data-slider-progress]');
    if (track && thumb) {
      track.addEventListener('click', function (e) {
        var rect  = track.getBoundingClientRect();
        var ratio = (e.clientX - rect.left) / rect.width;
        slider.scrollLeft = ratio * slider.scrollWidth;
      });
    }

    var debounceTimer;
    slider.addEventListener('scroll', function () {
      updateThumb();
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(updateArrows, 80);
    }, { passive: true });

    updateArrows();
    updateThumb();

    // Update on resize
    var ro = new ResizeObserver(function () { updateArrows(); updateThumb(); });
    ro.observe(slider);
  }

  /**
   * Recommandations Shopify — elles n'existent qu'au bout d'une requête :
   * `recommendations.products` est vide dans le rendu normal de la page, et
   * n'est renseigné que par l'URL de recommandations, qui renvoie la section
   * entière déjà rendue. On récupère donc du HTML, pas du JSON : les cartes
   * restent celles de `product-card.liquid`, avec l'ajout rapide, les badges
   * et la liste d'envies, qu'un rendu maison en JS n'aurait pas.
   */
  function loadRecommendations(section) {
    var url = section.dataset.recommendationsUrl;
    if (!url || section.dataset.recommendationsLoading) return;
    section.dataset.recommendationsLoading = '1';

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var holder = document.createElement('div');
        holder.innerHTML = text;
        var fresh = holder.querySelector('[data-product-recommendations]');
        if (!fresh || !fresh.querySelector('.product-slider__item')) {
          section.remove();
          return;
        }
        section.innerHTML = fresh.innerHTML;
        delete section.dataset.recommendationsUrl;
        delete section.dataset.recommendationsLoading;
        initSlider(section);
      })
      .catch(function () { section.remove(); });
  }

  /* La section est souvent loin sous la ligne de flottaison : on ne paie la
     requête que si le visiteur descend jusque-là. */
  function observe(section) {
    if (!('IntersectionObserver' in window)) { loadRecommendations(section); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.disconnect();
        loadRecommendations(section);
      });
    }, { rootMargin: '600px 0px' });
    io.observe(section);
  }

  function setup(section) {
    if (section.dataset.recommendationsUrl) observe(section);
    else initSlider(section);
  }

  function init() {
    document.querySelectorAll('.product-slider-section').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.product-slider-section');
    if (section) setup(section);
  });
})();
